import { render, staticRenderFns } from "./BIconTelegram.vue?vue&type=template&id=0905b65e&"
import script from "./BIconTelegram.vue?vue&type=script&lang=js&"
export * from "./BIconTelegram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports